export type MobileWebPlatform = 'ios' | 'android' | 'other'

export function mobileWebPlatform(): MobileWebPlatform {
  if (typeof navigator === 'undefined') return 'other'
  const ua = navigator.userAgent
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios'
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios'
  if (/Android/i.test(ua)) return 'android'
  return 'other'
}

/** Mobile web layout — narrow viewport, not installed PWA / native shell. */
export function isMobileWebBrowser(): boolean {
  if (typeof window === 'undefined') return false
  if (!window.matchMedia('(max-width: 960px)').matches) return false
  if (window.matchMedia('(display-mode: standalone)').matches) return false
  if ((navigator as Navigator & { standalone?: boolean }).standalone) return false
  return true
}

const DISMISS_KEY = 'redevicer.mobileAppSplashDismissed'

export function shouldShowMobileAppOnboarding(): boolean {
  if (!isMobileWebBrowser()) return false
  try {
    localStorage.removeItem('redevicer.mobileAppSplashDismissedAt')
    return sessionStorage.getItem(DISMISS_KEY) !== '1'
  } catch {
    return true
  }
}

export function dismissMobileAppOnboarding(): void {
  try {
    sessionStorage.setItem(DISMISS_KEY, '1')
  } catch {
    /* ignore */
  }
}

export function mobileAppSplashMediaQuery(): MediaQueryList | null {
  if (typeof window === 'undefined') return null
  return window.matchMedia('(max-width: 960px)')
}
